/**
 * microsoft.service.ts — Layer 3: Microsoft / Outlook Integration Domain
 */

import { getRequest, postRequest } from './http.service';
import {
  URL_OUTLOOK_CONTACTS_STATUS,
  URL_OUTLOOK_CONTACTS_OAUTH,
  URL_TEAMS_TRANSCRIPTS_AVAILABLE,
  URL_TEAMS_TRANSCRIPTS_IMPORT,
} from './url.service';

/** Check whether the current user has a connected Microsoft account */
export const checkMicrosoftConnectionStatus = () =>
  getRequest(URL_OUTLOOK_CONTACTS_STATUS);

/** Get the OAuth redirect URL for Microsoft sign-in */
export const getMicrosoftOAuthUrl = (redirectUrl: string) =>
  getRequest(URL_OUTLOOK_CONTACTS_OAUTH(redirectUrl));

/** Check whether a Teams recording/transcript is available for import yet */
export const fetchTeamsTranscriptsAvailable = (orgId: string, teamsOnlineMeetingId: string, prospoMeetingId: string) =>
  getRequest(URL_TEAMS_TRANSCRIPTS_AVAILABLE(orgId, teamsOnlineMeetingId, prospoMeetingId));

/** Import a Teams recording/transcript artifact into a Prospo meeting */
export const importTeamsTranscript = (orgId: string, payload: Record<string, unknown>) =>
  postRequest(URL_TEAMS_TRANSCRIPTS_IMPORT(orgId), payload);
